import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fleethuntConfig: TSPConfig = {
  key: 'fleethunt',
  name: 'FleetHunt',
  category: TSPCategory.API_KEY,
  helpText: (
    <ol>
      <li>
        Log into the FleetHunt dashboard at{' '}
        <a target='_self' href='https://app.fleethunt.ca/login'>
          https://app.fleethunt.ca/login
        </a>
        .
        <ol>
          <li>Hover over "Manage" and click on "API Keys"</li>
          <li>Click on "Generate API Key" and name the key "Axle"</li>
          <li>Copy the key under the column "API Key".</li>
        </ol>
      </li>
      <li>Input the copied API Key here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default fleethuntConfig;
